import { getTranslation } from '@services/translations';

export const CARDS = [
  { id: 'card0', content: 'This is the card at index 0' },
  { id: 'card1', content: 'This is the card at index 1' },
  { id: 'card2', content: 'This is the card at index 2' },
  { id: 'card3', content: 'This is the card at index 3' },
  { id: 'card4', content: 'This is the card at index 4' }
];

export const translations = () =>
  ({
    DND_REORDERING_INSTRUCTIONS: getTranslation(
      'survey.RANKING_DND_REORDERING_INSTRUCTIONS',
      "Rank the items below by dragging and dropping them in the desired position. After dragging and dropping the item, the other items will adjust accordingly. For example, moving it to position '1' will place the item at the top and move the current value to position '2'."
    ),

    DND_REORDERING_GRABBED: getTranslation(
      'survey.RANKING_DND_REORDERING_GRABBED',
      'Reordering #{ITEM} item at #{POSITION}'
    ),

    DND_REORDERING_DRAGGING: getTranslation(
      'survey.RANKING_DND_REORDERING_DRAGGING',
      'Reordering #{ITEM} item at #{POSITION}'
    ),

    DND_REORDERING_DROPPED: getTranslation(
      'survey.RANKING_DND_REORDERING_DROPPED',
      'The list has been reordered. #{ITEM} is now item #{POSITION} of #{TOTAL}'
    ),

    DND_REORDERING_CANCELED: getTranslation(
      'survey.RANKING_DND_REORDERING_CANCELED',
      'Reordering canceled'
    ),

    DND_REORDERING_FOCUSED: getTranslation(
      'survey.RANKING_DND_REORDERING_FOCUSED',
      'Draggable. Selected item #{ITEM}. #{POSITION} of #{TOTAL}.'
    ),

    DND_USAGE_INSTRUCTIONS: getTranslation(
      'survey.RANKING_DND_USAGE_INSTRUCTIONS',
      'Press Tab to focus on the first item on the list. Spacebar to select an item, Up down arrow to move item to new location. Press enter or spacebar to confirm reorder.'
    )
  }) as const;
